export default __webpack_public_path__ + "static/media/ic-reserva-utilizacao.7ae253d2.svg";